import React, { useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ModelStatus } from '../../../../services/Guide/guide';
import { scrollToTop } from '../../../../services/utils';
import { FormTrip } from './formTrip';
import TripInfoModel from './tripInfoModel';
import TripSummary from './tripSummary';

interface TripListContextValue {
  remove: (index: number) => void;
  append: (index: number) => void;
}

export const TripListContext = React.createContext<TripListContextValue>({
  remove: () => {},
  append: () => {},
});

export const TripListContainer = (props: any) => {
  const { t } = useTranslation();
  const { control, watch, getValues } = useFormContext();
  const [edit, setEdit] = useState(false);
  const [selectedFieldIndex, setSelectedFieldIndex] = useState(0);
  const [showDialog, setShowDialog] = useState(false);

  const { fields, remove, append } = useFieldArray({
    control,
    name: props.name,
  });
  const { currency } = getValues('guideProfile');

  const addHandler = () => {
    setSelectedFieldIndex(fields.length);
    props.setIsVisible(false);
    setEdit(false);
    append({
      status: ModelStatus.New,
      type: 'Full_Day',
      isSharedTrip: false,
      isSeasonalTrip: false,
      freeCancellation: '0',
      departure: '8',
      pricePerPerson: { value: undefined, currency: currency },
      priceifNotShared: { value: undefined, currency: currency },
      multiBoatTrip: false,
    });
    scrollToTop();
  };

  const updateHandler = (index: number) => {
    props.setIsVisible(false);
    setSelectedFieldIndex(index);
    setEdit(true);
    scrollToTop();
  };

  const previewHandler = (index: number) => {
    setSelectedFieldIndex(index);
    setShowDialog(true);
  };

  const onSave = () => {
    props.setIsVisible(true);
    scrollToTop();
  };

  const onCancel = (index: number, id: string) => {
    props.setIsVisible(true);
    if (!id) {
      remove(index);
    }
    scrollToTop();
  };

  return (
    <div>
      <TripListContext.Provider value={{ remove, append }}>
        {props.isVisible && (
          <div>
            <h5>{t('guide.trips.title')}</h5>
            {fields && fields.length > 0
            ?<p className="mt-3 mb-4">{t('guide.trips.descriptionChange')}</p>
            :
            <p className="mt-3 mb-4">{t('guide.trips.description')}</p>
            }
          </div>
        )}
        {fields.length > 0 && !props.isVisible && (
          <FormTrip
            edit={edit}
            index={selectedFieldIndex}
            name={props.name}
            key={fields[selectedFieldIndex].id}
            onSave={onSave}
            onCancel={onCancel}
          />
        )}

        {fields.length > 0 && showDialog && (
          <TripInfoModel
            show={showDialog}
            id={watch(`${props.name}[${selectedFieldIndex}].id`)}
            onClose={setShowDialog}
          />
        )}

        {props.isVisible &&
          fields &&
          fields.map((field: any, index: number) => (
            <TripSummary
              key={`${props.name}[${index}]`}
              tripInfo={watch(`${props.name}[${index}]`)}
              index={index}
              updateHandler={updateHandler}
              previewHandler={previewHandler}
            />
          ))}

        {props.isVisible && (
          <div className="done_text mb-3 mt-3">
            <a
              className="don_icon"
              onClick={addHandler}
              data-toggle="collapse"
              href="#collapseInputBoat"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i className="ion-md-add"></i>
            </a>
          </div>
        )}
      </TripListContext.Provider>
    </div>
  );
};
